<template>
  <v-container fluid class="pl-md-5 pb-15">
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <div v-if="list && !loading">
      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent="submit"
        lazy-validation
        class="mt-4"
      >
        <v-alert dense outlined type="error" v-if="error">
          <ul>
            <li v-for="item in error" :key="item.msg">{{ $t(item.msg) }}</li>
          </ul>
        </v-alert>
        <div class="text-h5 mb-5">{{ $t("EditListing") }}</div>
        <v-row>
          <v-col cols="12" md="7">
            <v-card class="mb-5" outlined>
              <div class="subtitle-1 pa-4 grey lighten-3">
                {{ $t("Cmsg10") }}
              </div>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-text-field
                      hide-details="auto"
                      v-bind:label="$t('ChangeLocation')"
                      :rules="reqRules"
                      v-model="list.location"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="list.location">
                  <v-col cols="12" md="6">
                    <v-text-field
                      hide-details="auto"
                      v-bind:label="$t('Addressline1')"
                      :rules="reqRules"
                      v-model="list.address.address1"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      hide-details="auto"
                      v-bind:label="$t('Addressline2')"
                      v-model="list.address.address2"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="list.location">
                  <v-col cols="12" md="4">
                    <v-text-field
                      hide-details="auto"
                      v-bind:label="$t('City')"
                      :rules="reqRules"
                      v-model="list.address.city"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      hide-details="auto"
                      v-bind:label="$t('Statesprovinces')"
                      :rules="reqRules"
                      v-model="list.address.statesprovinces"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      hide-details="auto"
                      v-bind:label="$t('ZIPPostalcode')"
                      :rules="reqRules"
                      v-model="list.address.postalcode"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="list.location">
                  <v-col cols="12" md="4">
                    <v-text-field
                      hide-details="auto"
                      v-bind:label="$t('Country')"
                      :rules="reqRules"
                      v-model="list.address.country"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div class="overline text-left pb-2">
                      {{ $t("RouteToYourPlace") }}
                    </div>
                    <div>
                      <vue-editor
                        v-model="list.property_route"
                        :editor-toolbar="customToolbar"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card class="mb-5" outlined>
              <div class="subtitle-1 pa-4 grey lighten-3">
                {{ $t("AddNearByAttractions") }}
              </div>
              <v-card-text class="pt-5">
                <v-row>
                  <v-col cols="5">
                    <v-text-field
                      hide-details="auto"
                      v-model="near_attraction.place"
                      type="text"
                      v-bind:label="$t('Place')"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      hide-details="auto"
                      v-model="near_attraction.distance"
                      type="number"
                      v-bind:label="$t('Distance')"
                      suffix="Miles"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-btn
                      x-large
                      depressed
                      class="text-right white--text"
                      color="light-blue"
                      @click="addAttraction"
                      :disabled="
                        !near_attraction.place || !near_attraction.distance
                      "
                    >
                      {{ $t("Add") }}
                    </v-btn>
                  </v-col>
                </v-row>
                <div class="pt-5">
                  <v-chip
                    v-for="(n, index) in list.near_attractions"
                    :key="index"
                    outlined
                    label
                    color="light-blue"
                    class="ma-2"
                    close
                    @click:close="() => removeAttraction(index)"
                  >
                    {{ n.place }} - {{ n.distance }} Miles {{ $t("away") }}
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>
            <v-card outlined>
              <div class="subtitle-1 pa-4 grey lighten-3">
                {{ $t("Cmsg14") }}
              </div>
              <v-card-text class="pt-5">
                <v-row>
                  <v-col>
                    <v-text-field
                      type="text"
                      hide-details="auto"
                      v-model="list.name"
                      :rules="reqRules"
                      v-bind:label="$t('Name')"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-textarea
                      outlined
                      hide-details="auto"
                      v-model="list.teaser"
                      v-bind:label="$t('Teaserdescription')"
                      :rules="reqRules"
                      rows="3"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div class="overline text-left">
                      {{ $t("Detaileddescription") }}
                    </div>
                    <vue-editor
                      v-model="list.description"
                      :editor-toolbar="customToolbar"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="5">
            <v-card class="mb-5" outlined>
              <div class="subtitle-1 pa-4 grey lighten-3">
                {{ $t("PropertyType") }}
              </div>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-radio-group v-model="list.type">
                      <v-radio
                        v-for="n in listType"
                        :key="n"
                        :label="$t(n)"
                        :value="n"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12">
                    <v-radio-group v-model="list.category">
                      <v-radio
                        v-for="n in listCategories"
                        :key="n"
                        :label="$t(n)"
                        :value="n"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12">
                    <div class="body-2 pb-5 text-center">
                      {{ $t("MaxNoofguestcanaccommodate") }}
                    </div>
                    <v-row>
                      <v-col>
                        <v-text-field
                          append-outer-icon="mdi-plus-circle"
                          prepend-icon="mdi-minus-circle"
                          outlined
                          v-model="list.no_guests"
                          :label="$tc('Adult', 2)"
                          readonly
                          @click:append-outer="list.no_guests++"
                          @click:prepend="
                            list.no_guests > 1
                              ? list.no_guests--
                              : list.no_guests
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          append-outer-icon="mdi-plus-circle"
                          prepend-icon="mdi-minus-circle"
                          outlined
                          v-model="list.no_childrens"
                          :label="$tc('Children', 2)"
                          readonly
                          @click:append-outer="list.no_childrens++"
                          @click:prepend="
                            list.no_childrens > 1
                              ? list.no_childrens--
                              : list.no_childrens
                          "
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field
                          append-outer-icon="mdi-plus-circle"
                          prepend-icon="mdi-minus-circle"
                          outlined
                          v-model="list.no_rooms"
                          :label="$tc('Noofrooms')"
                          readonly
                          @click:append-outer="list.no_rooms++"
                          @click:prepend="
                            list.no_rooms > 1 ? list.no_rooms-- : list.no_rooms
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          append-outer-icon="mdi-plus-circle"
                          prepend-icon="mdi-minus-circle"
                          outlined
                          v-model="list.no_bathrooms"
                          :label="$tc('Noofbathrooms')"
                          readonly
                          @click:append-outer="list.no_bathrooms++"
                          @click:prepend="
                            list.no_bathrooms > 1
                              ? list.no_bathrooms--
                              : list.no_bathrooms
                          "
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card class="mb-5" outlined>
              <div class="subtitle-1 pa-4 grey lighten-3">
                {{ $t("Houserules") }}
              </div>
              <v-card-text class="pt-5">
                <v-row>
                  <v-col v-if="houseRules">
                    <v-combobox
                      v-model="list.rules"
                      :items="houseRules"
                      :label="$t(`Restrictions`)"
                      multiple
                      outlined
                      chips
                      clear-icon=""
                    >
                      <template v-slot:selection="data">
                        <v-chip class="ma-1">
                          {{ $t(data.item) }}
                        </v-chip>
                      </template>
                      <template slot="item" slot-scope="data">
                        {{ $t(data.item) }}
                      </template>
                    </v-combobox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-combobox
                      v-model="list.check_in_times"
                      :items="items"
                      :label="$t(`CheckInTimes`)"
                      multiple
                      outlined
                      dense
                      chips
                    >
                      <template v-slot:selection="data">
                        <v-chip dark color="grey" class="mt-2 mb-2">
                          {{ data.item }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-combobox
                      v-model="list.check_out_times"
                      :items="items"
                      :label="$t(`CheckOutTimes`)"
                      multiple
                      outlined
                      dense
                      chips
                    >
                      <template v-slot:selection="data">
                        <v-chip dark color="grey" class="mt-2 mb-2">
                          {{ data.item }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="mb-5" outlined>
              <div class="subtitle-1 pa-4 grey lighten-3">
                {{ $t("Basicamenities") }}
              </div>
              <v-card-text class="pt-5" v-if="basicAmenitiesItem">
                <div
                  class="pb-10"
                  v-for="item in basicAmenitiesItem.docs"
                  :key="item._id"
                >
                  <div class="overline text-left mb-2 pl-3">{{ item._id }}</div>
                  <v-divider class="mb-3"></v-divider>
                  <v-row class="pt-4">
                    <v-col
                      cols="auto"
                      class="py-0"
                      v-for="doc in item.items"
                      :key="doc.ln_key"
                    >
                      <v-checkbox
                        class="ma-0 pa-0 subtitle-2"
                        dense
                        v-model="list.amenities"
                        :label="$t(doc.ln_key)"
                        :value="doc"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-footer fixed>
          <v-col class="text-center" cols="12">
            <v-btn type="submit" dark min-width="150" color="light-blue">
              <span class="mr-2">{{ $t("Save") }}</span>
            </v-btn>
            <v-btn
              color="light-blue"
              text
              class="ml-2"
              min-width="150"
              :to="{
                name: 'PartnerListingViewComponent',
                params: { id: parm }
              }"
            >
              <span>{{ $t("Back") }}</span>
            </v-btn>
          </v-col>
        </v-footer>
        <WaitDialogComponent :waitDialog="waitDialog" />
      </v-form>
    </div>
  </v-container>
</template>

<script>
// @ is an alias to /src
import timeoutMixin from "@/mixins/timeoutMixin.js";
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import listingsData from "@/assets/listings.json";
import ListingService from "@/services/ListingService";
import { VueEditor } from "vue2-editor";

export default {
  name: "EditListingComponent",
  components: {
    VueEditor,
    WaitDialogComponent
  },
  mixins: [timeoutMixin],
  data() {
    return {
      list: null,
      loading: true,
      parm: this.$route.params.id,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }]
      ],
      listCategories: listingsData.listCategories,
      locError: false,
      listType: listingsData.listType,
      basicAmenitiesItem: null,
      waitDialog: false,
      valid: null,
      error: null,
      reqRules: [value => !!value || this.$t("string719")],
      items: listingsData.times,
      near_attraction: {},
      houseRules: []
    };
  },
  created: function() {
    ListingService.editViewProperty({
      id: this.parm
    })
      .then(result => {
        this.list = result.data.item;
        this.loading = false;
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
    ListingService.listAmenities()
      .then(result => {
        this.basicAmenitiesItem = result.data;
        this.houseRules = this.basicAmenitiesItem.rules.map(e => {
          return e.ln_key;
        });
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
  },
  methods: {
    async submit() {
      await this.$refs.form.validate();
      if (!this.list.location) {
        return (this.error = [{ msg: "Enter Location" }]);
      }
      if (this.valid) {
        this.waitDialog = true;
        await ListingService.propertyUpdate(this.list)
          .then(() => {
            setTimeout(
              () => (
                (this.waitDialog = false),
                this.$router.push({
                  name: "PartnerListingViewComponent",
                  params: { id: this.parm }
                })
              ),
              500
            );
          })
          .catch(err => {
            this.error = err.response.data.errors;
            setTimeout(() => (this.waitDialog = false), 500);
          });
      }
    },
    removeAttraction(index) {
      this.list.near_attractions.splice(index, 1);
    },
    addAttraction() {
      this.list.near_attractions.push(this.near_attraction);
      this.near_attraction = {};
    }
  }
};
</script>

<style></style>
